<template>
  <el-container class="app_layout_container">
    <router-view @event="handleRouterViewEvent" />

    <login-dialog ref="loginDialog" @event="handleDialogEvent" />
    <reg-user-dialog auto-login ref="regUserDialog" @event="handleDialogEvent" />
    <reg-user-info-dialog ref="regUserInfoDialog" />
    <change-password-dialog ref="changePasswordDialog" />
    <account-setting-dialog ref="accountSettingDialog" />
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import { defineAsyncComponent, markRaw } from 'vue';
import { CaretTop } from '@element-plus/icons-vue';
import { loadJs } from "@/utils/loadResources";

export default {
  name: "Layout",
  components: {
    LoginDialog: defineAsyncComponent(() => import('@components/dialog/LoginDialog')),
    RegUserDialog: defineAsyncComponent(() => import('@components/dialog/RegUserDialog')),
    RegUserInfoDialog: defineAsyncComponent(() => import('@components/dialog/RegUserInfoDialog')),
    ChangePasswordDialog: defineAsyncComponent(() => import('@components/dialog/ChangePasswordDialog')),
    AccountSettingDialog: defineAsyncComponent(() => import('@components/dialog/AccountSettingDialog')),
  },
  data() {
    return {
      columnList: [],
      searchValue: '',
      searchArea: '',
      suffixIcon: markRaw(CaretTop),
    };
  },
  computed: {
    ...mapState([ 'setting', 'currColumn', 'userInfo' ]),
    ...mapState('techBlue', [ 'search_value' ]),
    isLogined() {
      return this.userInfo && this.isNotEmpty(this.userInfo.sid);
    },
    addBdTongJi() {
      if (this.setting.cms_add_bdtongji === 1) {
        return this.isNotEmpty(this.setting.cms_bdtongji_code);
      }
      return false;
    },
    topColumnList() {
      return this.columnList.filter(item => item.location !== 'bottom');
    },
    headPicUrl() {
      if (this.isNotEmpty(this.userInfo.head_pic)) {
        let head_pic = this.userInfo.head_pic;
        if (this.isNotEmpty(head_pic) && head_pic.indexOf('http://') === -1
            && head_pic.indexOf('https://') === -1) {
          head_pic = this.getFileUrl(head_pic);
        }
        return head_pic;
      }
      return '';
    }
  },
  watch: {
    $route: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async init() {
      $('html').addClass('app');
      await this.storeDispatch('initCmsSetting');
      if (this.addBdTongJi) {
        loadJs(`https://hm.baidu.com/hm.js?${ this.setting.cms_bdtongji_code }`);
      }
      await this.initColumnList();
    },
    initColumnList() {
      let _this = this;
      return _this.fetchData(_this.$api.API_GetCmsColumnList).then(result => {
        _this.columnList = result.data || [];
        if (_this.isNotEmptyList(_this.columnList)) {
          _this.columnList.forEach(item => {
            if (_this.isNotEmpty(item.icon_url)) {
              item.icon_path = _this.getFileUrl(item.icon_url);
            }
          });
        }
        _this.storeCommit('SET_COLUMN_LIST', _this.columnList);
        if (_this.isNotEmpty(_this.currColumn.sid)) {
          let filter = _this.columnList.filter(item => item.sid === _this.currColumn.sid);
          if (!_this.isNotEmptyList(filter)) {
            _this.storeCommit('SET_CURR_COLUMN', columnList[0]);
          }
        } else {
          _this.storeCommit('SET_CURR_COLUMN', _this.columnList[0]);
        }
      }).catch(() => {
      });
    },
    handleRouterViewEvent(event) {
      const _this = this;
      if (event.type === 'clickLogin') {
        if (_this.$refs['loginDialog']) {
          _this.$refs['loginDialog'].openDialog({}, true);
        }
        return;
      }
      if (event.type === 'info') {
        if (this.$refs['regUserInfoDialog']) {
          this.$refs['regUserInfoDialog'].openDialog({}, true);
        }
        return;
      }
      if (event.type === 'change_pwd') {
        if (this.$refs['changePasswordDialog']) {
          this.$refs['changePasswordDialog'].openDialog({}, true);
        }
        return;
      }
      if (event.type === 'account_setting') {
        if (this.$refs['accountSettingDialog']) {
          this.$refs['accountSettingDialog'].openDialog({
            data: this.userInfo,
          }, true);
        }
      }
    },
    handleDialogEvent(event) {
      if (event.type === 'regUser') {
        if (this.$refs['regUserDialog']) {
          this.$refs['regUserDialog'].openDialog({}, true);
        }
        return;
      }
      if (event.type === 'autoLogin') {
        if (this.$refs['loginDialog']) {
          this.$refs['loginDialog'].closeDialog();
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.app_layout_container {
  width: 100%;
  height: 100%;
  background-color: #f7f7f7;
}

html, body {
  min-width: auto !important;
  overflow: hidden;
}
</style>

<style scoped>
html, body {
  min-width: auto !important;
  overflow: hidden;
}
</style>